/**
 * How a payment's card reads (wallets plan, code fix 1). Pure and browser-safe: no
 * Stripe import, so it reaches the webapp through the browser barrel.
 *
 * A Link payment funded by a bank account comes from Stripe as a card with brand
 * `link`, a made-up last four (`0000`) and a made-up expiry (12/2040). Stripe asks
 * that it be shown as a Link payment. Where Telify reads a card it keeps the brand
 * and drops the made-up digits, and every place that draws card details reads
 * "Link" for it.
 */

/** What a Link payment reads, wherever card details show. */
export const LINK_LABEL = 'Link';

/** True for a Link payment: its last four and expiry are made up and never kept or shown. */
export function isLinkCard(brand: string | null | undefined): boolean {
  return typeof brand === 'string' && brand.toLowerCase() === 'link';
}
